import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './AuthContext';
import { ThemeProvider } from './ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Sites from './pages/Sites';
import Plugins from './pages/Plugins';
import Themes from './pages/Themes';
import Upload from './pages/Upload';
import CoreUpdates from './pages/CoreUpdates';
import Activity from './pages/Activity';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import FormCleanup from './pages/FormCleanup';
import EmailCleanup from './pages/EmailCleanup';
import Agent from './pages/Agent';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'var(--bg)',color:'var(--text3)',fontFamily:'Inter, sans-serif' }}>Loading...</div>;
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Toaster position="top-right" toastOptions={{ style: { background:'var(--card-bg)', color:'var(--text)', border:'1px solid var(--border)', borderRadius:'12px', fontSize:'13px', boxShadow:'var(--shadow)' } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/login"    element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password"  element={<ResetPassword />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index          element={<Dashboard />} />
            <Route path="sites"   element={<Sites />} />
            <Route path="plugins" element={<Plugins />} />
            <Route path="themes"  element={<Themes />} />
            <Route path="upload"  element={<Upload />} />
            <Route path="core"    element={<CoreUpdates />} />
            <Route path="forms"   element={<FormCleanup />} />
            <Route path="email"   element={<EmailCleanup />} />
            <Route path="agent"   element={<Agent />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="activity" element={<Activity />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}
